import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-joyrideLight dark:bg-joyrideNavy transition-colors">
      <div className="text-center space-y-6 px-4">
        <h1 className="text-6xl font-lobster text-joyridePurple dark:text-joyrideCyan dark:text-shadow-lg">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-joyrideNavy dark:text-joyrideLight dark:text-shadow-sm">
          Sivua ei löydy!
        </h2>
        <p className="text-lg text-joyrideNavy dark:text-joyrideLight dark:text-shadow-lg">
          Valitettavasti etsimääsi sivua ei löytynyt. Se saattaa olla poistettu tai siirretty.
        </p>
        <Link
          to="/"
          className="
            inline-block px-6 py-2 rounded-full shadow-lg
            bg-joyrideNavy 
            text-joyrideNavy 
            dark:bg-joyrideCyan
            dark:text-joyrideNavy 
            dark:hover:bg-joyrideLight
            font-semibold text-sm
            transform transition-all duration-300
            hover:scale-105

            hover:bg-joyridePurple 
            hover:text-joyrideLight
          "
        >
          Palaa etusivulle
        </Link>
      </div>
    </div>
  );
}
